import { Controller } from '@hotwired/stimulus'
import { put, post } from '../lib/request'

export default class extends Controller {
  static targets = ['menu', 'collectionsMenu']

  static values = {
    update: String,
    destroy: String,
    id: Number,
  }

  connect = () => {
    this.open = false
  }

  openMenu = () => {
    this.menuTarget.style.visibility = 'visible'
    this.open = true

    setTimeout(() => {
      document.addEventListener('click', this.checkClick)
    }, 500)
  }

  closeMenu = () => {
    this.menuTarget.style.visibility = 'hidden'
    this.open = false

    setTimeout(() => {
      document.removeEventListener('click', this.checkClick)
    }, 500)
  }

  checkClick = (event) => {
    const closest = event.target.closest('[data-mobile-product-target="menu"]')

    if (this.open && closest !== this.menuTarget) this.closeMenu()
  }

  hide = () => {
    return this.updateProduct(false)
  }

  show = () => {
    return this.updateProduct(true)
  }

  updateProduct = (visible) => {
    const params = {
      print_product: {
        visible: visible,
      },
    }

    return put(this.updateValue, { responseKind: 'turbo-stream', body: JSON.stringify(params) })
  }

  destroy = () => {
    const params = { products: [this.idValue] }

    return post(this.destroyValue, { responseKind: 'turbo-stream', body: JSON.stringify(params) })
  }

  addToCollection = ({ params: { url } }) => {
    return put(url, { responseKind: 'turbo-stream' })
  }
}
